import { getIdFromPath } from "lqx-react";
import React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { IngestPage } from ".";
import { NotAllowed } from "../components/not-allowed";

export const IngestRouter = () => {
    const current = getIdFromPath(3);

    return <>
        {
            !current && Can(UserEntitlementCatalogs.ViewInBlockAnAssetButton) ? (() => <IngestPage key={Math.random()} />)() :
                current === 'edit' && Can(UserEntitlementCatalogs.EditImportJobPage) ? (() => <IngestPage key={Math.random()} />)() :
                    <NotAllowed />
        }
    </>
}
